"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridSort = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var GridSort = function GridSort() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(0.706 0.5)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M3,8.5l4,3.646L11,8.5",
        transform: "translate(-3 -1.293)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        y1: "10.853",
        transform: "translate(4)"
      })]
    })
  });
};
exports.GridSort = GridSort;